import { connect } from '../../../../common/react-redux';
import ModerateTableRow from './presenter';
import { getQuizSessionsByIds } from '../../../../common/selectors/quizSessions';
export function mapStateToProps(state, ownProps) {
  var quizSessionIds = ownProps.rowData.quizSessionIds;
  var quizSessions = getQuizSessionsByIds(state, quizSessionIds).filter(function (qs) {
    return qs.isLoaded() && !qs.pending();
  });
  return {
    quizSessions: quizSessions
  };
}
var connectedModerateTableRow = connect(mapStateToProps)(ModerateTableRow);
// This ugly hack is necessary because the InstUI v7 Table.Body only renders components with name 'Row'.
connectedModerateTableRow.displayName = 'Row';
export default connectedModerateTableRow;